import { LayoutGrid, List } from 'lucide-react';
import { cn } from '../../lib/utils';

export function ViewToggle({ view, onChange, className }) {
  return (
    <div className={cn("flex items-center bg-gray-100 rounded-lg p-0.5", className)} data-testid="view-toggle">
      <button
        onClick={() => onChange('card')}
        className={cn(
          "flex items-center gap-1 px-2.5 py-1 rounded-md text-xs font-medium transition-all",
          view === 'card' ? "bg-white text-gray-900 shadow-sm" : "text-gray-500 hover:text-gray-700"
        )}
        data-testid="view-toggle-card"
      >
        <LayoutGrid className="h-3.5 w-3.5" />
        <span className="hidden sm:inline">Card</span>
      </button>
      <button
        onClick={() => onChange('list')}
        className={cn(
          "flex items-center gap-1 px-2.5 py-1 rounded-md text-xs font-medium transition-all",
          view === 'list' ? "bg-white text-gray-900 shadow-sm" : "text-gray-500 hover:text-gray-700"
        )}
        data-testid="view-toggle-list"
      >
        <List className="h-3.5 w-3.5" />
        <span className="hidden sm:inline">List</span>
      </button>
    </div>
  );
}

export function ScrollableTabs({ children, className }) {
  return (
    <div className={cn("flex items-center gap-1.5 overflow-x-auto pb-1 scrollbar-hide -mx-1 px-1", className)} data-testid="scrollable-tabs">
      {children}
    </div>
  );
}

export function FilterPill({ active, onClick, children, count, testId }) {
  return (
    <button
      onClick={onClick}
      className={cn(
        "px-2.5 py-1 rounded-full text-xs whitespace-nowrap transition-all flex-shrink-0",
        active ? "bg-gray-900 text-white" : "bg-gray-100 text-gray-600 hover:bg-gray-200"
      )}
      data-testid={testId}
    >
      {children}{count !== undefined ? ` (${count})` : ''}
    </button>
  );
}
